export default "__VITE_ASSET__CH489pjj__"